"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircularProgressExperiment = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _components = require("@knxlab/components");

var _reactHooks = require("@knxlab/react-hooks");

var _reactNativeSvg = require("react-native-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = _reactNative.StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white'
  }
});

var TestSVG = function TestSVG(props) {
  var size = props.size,
      strokeWidth = props.strokeWidth,
      text = props.text;
  var radius = (size - strokeWidth) / 2;
  var circum = radius * 2 * Math.PI;
  var svgProgress = 100 - props.progressPercent;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Svg, {
    width: size,
    height: size
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Circle, _extends({
    cx: size / 2,
    cy: size / 2,
    r: radius,
    fill: "pink",
    stroke: props.pgColor ? props.pgColor : "#3b5998",
    strokeDasharray: "".concat(circum, " ").concat(circum),
    strokeDashoffset: radius * Math.PI * 2 * (svgProgress / 100),
    strokeLinecap: "round",
    transform: "rotate(-90, ".concat(size / 2, ", ").concat(size / 2, ")")
  }, {
    strokeWidth: strokeWidth
  })));
};

var CircularProgressExperiment = function CircularProgressExperiment() {
  var timer = 2000;

  var _React$useState = _react["default"].useState(timer),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      countDown = _React$useState2[0],
      setCountDown = _React$useState2[1];

  (0, _reactHooks.useInterval)(function () {
    if (countDown === 0) {
      return;
    }

    setCountDown(countDown - 10);
  }, 100);
  var progressPercent = 100 * (timer - countDown) / timer;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(TestSVG, {
    size: 100,
    strokeWidth: 10,
    progressPercent: 20
  }), /*#__PURE__*/_react["default"].createElement(_components.CircularProgress, {
    size: 120,
    strokeWidth: 10,
    text: Math.round(countDown / 100),
    progressPercent: progressPercent
  }), /*#__PURE__*/_react["default"].createElement(_components.AnimatedCircularProgress, {
    rotation: -90,
    size: 120,
    width: 15,
    fill: progressPercent,
    tintColor: "#00e0ff",
    backgroundColor: "#3d5875",
    lineCap: "round",
    arcSweepAngle: 180
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, null, Math.round(countDown / 100))));
};

exports.CircularProgressExperiment = CircularProgressExperiment;